import { Button, Fade, Icon, IconButton, Modal, TextField } from "@material-ui/core";
import { format } from "date-fns";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { asyncPaymentMethod } from "store/reducers/paymentPlan.reducer";
import { useStyles } from "views/PaymentPlan/styles/styles";

const DateModal = ({activeModal, handleOpen, installment, expandedId}) => {
  const {id} = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [expirationDate, setExpirationDate] = useState();
  const {loadingPaymentMethod} = useSelector((state) => state.PaymentPlan);

    const onClose = () => {
      handleOpen(null);
      setExpirationDate(null);
    }

    function handleNewExpirationDate() {  
      const data = {
        dateToExpired: expirationDate,
        method: activeModal,
      };
  
      dispatch(asyncPaymentMethod({ id, num: installment, data, onClose: onClose, expandedId}));
    }
  
    return (
      <Modal
      open={!!activeModal}
      onClose={onClose}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Fade in={!!activeModal}>
       <main className={classes.paper}>
         <header className={classes.modalHeader}>
           <span>{activeModal === 'boleto' ? 'Gerar um novo boleto' : 'Gerar Pix'}</span>
           <IconButton className={classes.button_close} onClick={onClose}>
             <Icon>close</Icon>
           </IconButton>
         </header>
  
         <div className={classes.modalContent}>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <TextField
              id="date"
              label="Nova data de expiração"
              variant="outlined"
              type="date"
              className={classes.textField}
              value={expirationDate}
              onChange={(e) => setExpirationDate(e.target.value)}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                min: format(new Date(), 'yyyy-MM-dd')
              }}
            />
            {!expirationDate && <span style={{color: 'red', fontSize: '12px', marginTop: '20px'}}>*Selecione uma data de Expiração</span>}
          </div>
  
          <div>
            <Button
              variant="contained"
              color="primary"
              style={{marginRight: '10px'}}
              disabled={loadingPaymentMethod || !expirationDate}
              onClick={() => handleNewExpirationDate()}
            >
              {loadingPaymentMethod ? 'Carregando...' : 'Gerar'}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              Voltar
            </Button>
          </div>
  
         </div>
      </main>
      </Fade >
    </Modal>
    )
  };

export default DateModal;